/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacthirelawyeranchor3Inputs */

const en_artifacthirelawyeranchor3 = /** @type {(inputs: Artifacthirelawyeranchor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct lawyer engagement when you need it. The pack above usually covers what most homeowners need first.`)
};

const pt_artifacthirelawyeranchor3 = /** @type {(inputs: Artifacthirelawyeranchor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoio direto de advogado quando precisar. O pack acima costuma cobrir o que a maioria dos proprietários precisa primeiro.`)
};

/**
* | output |
* | --- |
* | "Direct lawyer engagement when you need it. The pack above usually covers what most homeowners need first." |
*
* @param {Artifacthirelawyeranchor3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifacthirelawyeranchor3 = /** @type {((inputs?: Artifacthirelawyeranchor3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacthirelawyeranchor3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifacthirelawyeranchor3(inputs)
	return pt_artifacthirelawyeranchor3(inputs)
});
export { artifacthirelawyeranchor3 as "artifactHireLawyerAnchor" }